import { useParams } from "react-router";

import Box from "ds/components/Box";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeader from "components/ViewHeader";
import useTitle from "hooks/useTitle";
import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import NotFoundPage from "components/error/NotFoundPage";
import useErrorHandle from "hooks/useErrorHandle";
import useUserGuideGroup from "shared/UserGuides/useUserGuideGroup";
import { UserGuideStartLocation } from "shared/UserGuides/analytics";
import UserGuideGroup from "components/UserGuideGroup";
import UserGuideGroupSkeleton from "components/UserGuideGroup/Skeleton";
import Badge from "ds/components/Badge";
import useIsOnboardingCertificatesAvailable from "hooks/useIsOnboardingCertificatesAvailable";

import LaunchPadUserGuidesGroupSidePanel from "./SidePanel";
import styles from "./styles.module.css";

const LaunchPadUserGuidesGroup = () => {
  const { userGuideGroupId } = useParams();
  const isOnboardingCertificatesAvailable = useIsOnboardingCertificatesAvailable();

  const { userGuideGroup, loading, error } = useUserGuideGroup({ id: userGuideGroupId! });

  const title = userGuideGroup?.name;
  const isComingSoon =
    !!userGuideGroup && (!userGuideGroup.chapters || userGuideGroup.chapters.length === 0);
  const showSidebar = isOnboardingCertificatesAvailable && !isComingSoon;

  useTitle(`LaunchPad · ${title}`);

  useBreadcrumbs([
    {
      title: "LaunchPad",
      link: "/launchpad",
    },
    {
      title: title || "User Guides Group",
    },
  ]);

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (!loading && !userGuideGroup) {
    return <NotFoundPage />;
  }

  const mainContent = (
    <>
      {loading && !userGuideGroup && <UserGuideGroupSkeleton />}
      {userGuideGroup && (
        <UserGuideGroup
          userGuideGroup={userGuideGroup}
          groupId={userGuideGroupId!}
          location={UserGuideStartLocation.Launchpad}
        />
      )}
    </>
  );

  return (
    <>
      <ViewHeader>
        <ViewHeaderWrapper>
          <Box direction="row" align="center" gap="medium">
            <ViewHeaderTitle>{title}</ViewHeaderTitle>
            {!loading && isComingSoon && <Badge type="weak" variant="gray" text="Coming soon" />}
          </Box>
        </ViewHeaderWrapper>
      </ViewHeader>
      {showSidebar ? (
        <Box className={styles.gridContainer} grow="1" fullHeight>
          <Box
            className={styles.mainColumn}
            surfaceColor="quaternary"
            direction="column"
            scrollable
          >
            {mainContent}
          </Box>
          <Box className={styles.sideColumn} padding="large" direction="column" gap="large">
            <LaunchPadUserGuidesGroupSidePanel userGuideGroup={userGuideGroup} />
          </Box>
        </Box>
      ) : (
        <Box surfaceColor="quaternary" grow="1" fullHeight>
          {mainContent}
        </Box>
      )}
    </>
  );
};

export default LaunchPadUserGuidesGroup;
